<div class="not-found-container">
  <div class="not-found-content">
    <div class="error-icon" aria-hidden="true">
      <span class="error-number">404</span>
    </div>

    <h1 class="error-title">Page Not Found</h1>

    <p class="error-description">
      The page you are looking for might have been removed, had its name
      changed, or is temporarily unavailable.
    </p>

    <div class="error-actions">
      <a
        routerLink="/"
        class="back-to-login-btn"
        role="button"
        aria-label="Return to login page"
      >
        <span class="btn-icon" aria-hidden="true">←</span>
        Back to Login
      </a>
    </div>

    <div class="help-text">
      <p>If you believe this is an error, please contact support.</p>
    </div>
  </div>
</div>
